<template>
  <AppButton
    v-for="storm in report.storm_frequencies"
    :key="`${storm.frequency}-${storm.duration}`"
    :variant="isActive(storm.frequency, storm.duration)"
    @click="selectFrequency(storm.frequency, storm.duration)"
    class="mb-20px mr-10px"
  >
    {{ formatDuration(storm.duration) }} {{ storm.frequency }}-year storm
  </AppButton>
</template>

<script setup>
import { ref, watch } from "vue";
import { AppButton } from "@/components/ui";

const props = defineProps({
  report: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Number,
    required: true,
  },
  duration: {
    type: Number,
    required: true,
  },
});

const isActive = (frequency, duration) => {
  return frequency === props.modelValue && duration === props.duration ? "primary" : "outlined";
};

const emit = defineEmits(["update:modelValue", "update:duration"]);

const selectedFrequency = ref(props.modelValue);
const selectedDuration = ref(props.duration);

watch(
  () => props.modelValue,
  (newValue) => {
    selectedFrequency.value = newValue;
  }
);

watch(
  () => props.duration,
  (newValue) => {
    selectedDuration.value = newValue;
  }
);

const selectFrequency = (frequency, duration) => {
  selectedFrequency.value = frequency;
  selectedDuration.value = duration;
  emit("update:modelValue", frequency);
  emit("update:duration", duration);
};

const formatDuration = (minutes) => {
  if (minutes < 60) {
    return `${minutes}-minute`;
  } else if (minutes < 1440) {
    const hours = minutes / 60;
    return `${hours}-hour`;
  } else {
    const days = minutes / 1440;
    return `${days * 24}-hour`;
  }
};
</script>

<style lang="scss" scoped>
.storm-frequency-selector {
  gap: 10px;
}
</style>
